module.exports = __webpack_public_path__ + "static/media/LK_Arrow Down.4c306167.svg";